module.exports = __webpack_public_path__ + "static/media/icon-header-project.f952032c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Header/assets/icon-header-project.svg
// module id = 1510
// module chunks = 193